module.exports = __webpack_public_path__ + "static/mobile-cheese-f0af8607fdbe9583bb89e2aabda960a1.png";